module.exports = __webpack_public_path__ + "img/adeprotur.4d3f7367.png";